module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1235.fdd9d68f.png";